<template id="clearCacheData">
    <span class="web-action-btn pull-right" v-if="cachEnabled" style="line-height:27px;" >
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <button  class="btn btn-secondary ml-1"  v-on:click.prevent="cacheClear" > 
            <i class="fp-clear-cache bold" style="font-size:14px;"> </i> Clear Cache
        </button>
    </span>
</template>               

<script>
import Vue from 'vue';
import EventBus from './event-bus';

export default {
    name: "clearCacheData",
    props: {
        pageKey: {
            type: Array,
            required: false,
            default:undefined
        },
    },
    data: () => ({
            loading:false,
            cachEnabled:false,
    }),
    mounted: function() {
        
        var self = this;
        var isCacheEnabled = localStorage.getItem("cache_enabled"); 
        if ( isCacheEnabled == "true" ) {
            self.cachEnabled = true;
        } 
        
    },
    
    methods: {
       cacheClear() {
            var self = this;
            var key=self.pageKey;
            // console.log(key);
            self.loading = true;
             $.ajax({
                    url: process.env.ROOT_API + "/cache/remove",
                    type: "POST",
                    data: {'key':self.pageKey},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                       
                        if (data.status == "success") {
                            window.location.reload(true);
                        } 
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;                      
                        // self.generateStatusCodeMessage(jqXHR,false,'clear-cache-data')
                    }
                });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ClearCacheData.vue